import { Button, FormControl, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useApi } from "../../contexts/ApiContext";
import FormLabel from "../FormLabel";
import { InputProps } from "./InputProps";

export interface ButtonSelectionOption {
  label: string;
  value: string;
}

interface ButtonSelectionInputProps
  extends Omit<InputProps, "onChange" | "value"> {
  onChange: (values: string[]) => void;
  value: string[];
  options: ButtonSelectionOption[];
  multi?: boolean;
  id?: string;
}

const ButtonSelectionInput: React.FC<ButtonSelectionInputProps> = ({
  options,
  label,
  value,
  onChange,
  error,
  helperText,
  multi = false,
  id,
}) => {
  const [selected, setSelected] = useState<ButtonSelectionOption[]>(
    options.filter((o) => value.includes(o.value))
  );
  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  const emptyState = (
    <Typography variant={"caption"}>There are no availabe slots</Typography>
  );

  const handleSelect = (option: ButtonSelectionOption) => {
    if (selected.find((o) => o.value === option.value)) {
      setSelected((prevState) =>
        prevState.filter((o) => o.value !== option.value)
      );
    } else {
      setSelected((prevState) => [...prevState, option]);
    }
  };

  useEffect(() => {
    let val = selected;
    if (!multi && selected.length > 1) {
      val = [selected[selected.length - 1]];
    }
    setSelected(val);
    onChange(val.map((s) => s.value));
  }, [selected]);

  console.info("selected", selected);
  console.info(
    "options",
    options,
    !!selected.find((s) => s.value === options[0].value)
  );

  return (
    <FormControl id={id} disabled={isDisabled}>
      <Stack gap={1}>
        <FormLabel error={error}>{label}</FormLabel>

        <Stack gap={2} direction={"row"} flexWrap={"nowrap"}>
          {options.length
            ? options.map((option) => (
                <Button
                  disabled={isDisabled}
                  key={option.value}
                  onClick={() => handleSelect(option)}
                  size={"small"}
                  sx={{
                    backgroundColor: selected.find(
                      (s) => s.value === option.value
                    )
                      ? "black"
                      : "#F5F5F4",
                    color: selected.find((s) => s.value === option.value)
                      ? "white"
                      : "black",
                    borderRadius: 3,
                  }}
                  color={
                    selected.find((s) => s.value === option.value)
                      ? "blackButton"
                      : "secondary"
                  }
                >
                  {option.label}
                </Button>
              ))
            : emptyState}
        </Stack>
      </Stack>
    </FormControl>
  );
};

export default ButtonSelectionInput;
